export enum VideoSource {
  UPLOAD = "upload",
  OTHER = "other",
  YOUTUBE = "youtube",
  VIMEO = "vimeo",
  WHATCHADO = "whatchado",
}
